
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { useDispatch, useSelector  } from 'react-redux';
import Feature from 'ol/Feature';
import isNil from 'lodash/isNil';

import { IfComp, PanelTitle } from '../../core';
import { sagas as sagasMap } from '../../map';
import { useSearchDefinition } from '../../search';

import usePrintDefinition from '../hooks/usePrintDefinition';
import { getUi } from '../reducers'
import { getIsGeoActive } from '../reducers/ui';
import { getActions } from '../sagas';

import PrintForm from './PrintForm';

const PrintPanel = ({}) => {

    const classNames = mergeStyleSets({
        PrintPanel: {
            padding: 4
        },
    });

    const dispatch = useDispatch();
    const printActions = getActions(dispatch);
    const mapActions = sagasMap.getActions(dispatch);

    const printDefinition = usePrintDefinition();
    const searchDefinition = useSearchDefinition();
    const isGeoActive = useSelector(state => getIsGeoActive(getUi(state.print)));

    React.useEffect(() => {
        if (isGeoActive) {
            mapActions.setToolsMode('INPUT_POLYGON');
        }
    }, [isGeoActive]);

    const handleSetGeomCondition = (geometry, condition) => {
        printActions.setGeomCondition(geometry, condition);
    }

    const handleSetGeometry = (geometry, zoomToGeometry, title) => {
        let feature = (geometry)
            ? new Feature({geometry: geometry})
            : null;

        mapActions.addCommand('SET_TEMP_FEATURE', {features: feature ? [feature] : []});
        mapActions.setTempFeature(feature);
        if (zoomToGeometry) {
            mapActions.addCommand('ZOOM_FEATURE', {geometry: geometry});
        }

        if (!isNil(title)) {
            printActions.setParamValue('title', title);
        }
    }

    const handleSetIsGeoActive = (active) => {
        mapActions.setToolsMode(
            active ? 'INPUT_POLYGON' : 'DEFAULT'
        );
        printActions.setIsGeoActive(active);
    }

    const handleSetIsValid = (isValid) => {
        printActions.setIsValid(isValid);
    }

    const handleSetParamValue = (paramId, value) => {
        printActions.setParamValue(paramId, value);
    }

    const handleSelectReport = (reportId, reportType) => {
        printActions.selectReport(reportId, reportType);
        mapActions.setTempFeature(null);
        mapActions.addCommand('SET_TEMP_FEATURE', {features: []});
    }

    const isLoaded = printDefinition.reportDefinition && searchDefinition.searchDefinition;

    return (
        <Stack verticalFill className={classNames.PrintPanel} tokens={{childrenGap: 4}}>
            <Stack.Item align="stretch">
                <PanelTitle title="TISK" />
            </Stack.Item>
            <Stack.Item align="stretch">
                <IfComp cond={isLoaded}>
                    <PrintForm
                        onSelectReport={handleSelectReport}
                        onSetGeometry={handleSetGeometry}
                        onSetGeomCondition={handleSetGeomCondition}
                        onSetIsGeoActive={handleSetIsGeoActive}
                        onSetIsValid={handleSetIsValid}
                        onSetParamValue={handleSetParamValue}
                    />
                </IfComp>
            </Stack.Item>
            <Stack.Item align="stretch">
                <IfComp cond={! isLoaded}>
                    <div>Nahrávám...</div>
                </IfComp>
            </Stack.Item>
        </Stack>
    );
}

export default PrintPanel;
